export default "__VITE_ASSET__FB5SuHu8__"